import { Link } from 'react-router-dom';

export default function ArticleCTASection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="bg-primary-50 rounded-3xl p-8 md:p-12 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-48 h-48 bg-primary-200/30 rounded-full -translate-y-1/2 translate-x-1/4"></div>
          <div className="absolute bottom-0 left-0 w-36 h-36 bg-accent-200/20 rounded-full translate-y-1/3 -translate-x-1/4"></div>

          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                Guida Completa <strong>Itaobuy Spreadsheet</strong>
              </h2>
              <p className="text-sm md:text-base text-foreground-600 mb-6 leading-relaxed">
                Leggi la nostra guida approfondita con tutorial passo dopo passo, analisi della sicurezza, consigli pratici e molto altro. Tutto quello che devi sapere su Itaobuy Spreadsheet in un unico articolo.
              </p>
              <Link
                to="/articolo/guida-completa-itaobuy-spreadsheet"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line"></i>
                Leggi la Guida Completa
              </Link>
            </div>
            <div className="flex-shrink-0">
              <div className="w-28 h-28 md:w-36 md:h-36 flex items-center justify-center rounded-3xl bg-accent-500 text-background-50">
                <i className="ri-article-line text-4xl md:text-5xl"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}